import { Link } from "react-router-dom";
import { FileText, FolderPlus, UserPlus, Receipt, Wallet, Timer } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function QuickActionsBar() {
  const actions = [
    {
      key: "invoice",
      label: "Rechnung",
      icon: FileText,
      to: "/invoices?create=1",
      testId: "quick-action-new-invoice",
    },
    {
      key: "project",
      label: "Projekt",
      icon: FolderPlus,
      to: "/projects?create=1",
      testId: "quick-action-new-project",
    },
    {
      key: "customer",
      label: "Kunde",
      icon: UserPlus,
      to: "/customers?create=1",
      testId: "quick-action-new-customer",
    },
    {
      key: "expense",
      label: "Ausgabe",
      icon: Receipt,
      to: "/finances?create=expense",
      testId: "quick-action-new-expense",
    },
    {
      key: "income",
      label: "Einnahme",
      icon: Wallet,
      to: "/finances?create=income",
      testId: "quick-action-new-income",
    },
    {
      key: "timer",
      label: "Zeit",
      icon: Timer,
      to: "/time-tracking?create=1",
      testId: "quick-action-add-time",
    },
  ];

  return (
    <div className="sticky top-16 z-40" data-testid="quick-actions-bar">
      <div className="bg-white/95 backdrop-blur border-b border-gray-200 shadow-sm">
        <div className="px-4 py-3 flex flex-col gap-3 md:flex-row md:items-center md:gap-6">
          <div className="flex flex-col shrink-0">
            <span className="text-sm uppercase tracking-wide text-emerald-600 font-semibold">Quick Actions</span>
            <span className="text-xs text-gray-500">Schnellzugriff auf bestehende Bereiche</span>
          </div>

          <div className="flex-1 overflow-x-auto">
            <div
              className="flex items-center gap-2 flex-nowrap pb-1"
              data-testid="quick-actions-row"
            >
              {actions.map((action) => {
                const Icon = action.icon;
                return (
                  <Button
                    key={action.key}
                    variant="outline"
                    className="gap-2 whitespace-nowrap text-xs h-8 px-3"
                    data-testid={action.testId}
                    asChild
                  >
                    <Link to={action.to}>
                      <Icon className="h-3.5 w-3.5" />
                      {action.label}
                    </Link>
                  </Button>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}